import { pollSegmentTaskMock } from './segmentPollMock';

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function mockSubmitSegmentTask(projectId, durationSeconds, options = {}) {
  await delay(300);
  const taskId = `task-mock-${Date.now()}`;
  return pollSegmentTaskMock(taskId, projectId, durationSeconds, options);
}
